import React, { useRef } from 'react';
import RfiFileUpload from './RfiFileUpload';
import RfiQuestions, { RfiQuestionsRef } from './RfiQuestions';

interface RfiContainerProps {
  onCitationClick: (citationId: string, page: number, citation?: { file_name?: string; fund?: string; as_of_date?: string }) => void;
}

const RfiContainer: React.FC<RfiContainerProps> = ({ onCitationClick }) => {
  const questionsRef = useRef<RfiQuestionsRef>(null);

  const handleFileUploaded = (questions: any[], threadId: string) => {
    if (questionsRef.current) {
      questionsRef.current.handleFileUploaded(questions, threadId);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
      <div className="lg:col-span-1">
        <RfiFileUpload onFileUploaded={handleFileUploaded} />
      </div>
      <div className="lg:col-span-2">
        <RfiQuestions ref={questionsRef} onCitationClick={onCitationClick} />
      </div>
    </div>
  );
};

export default RfiContainer;
